import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useSearchParams, Link, useNavigate } from 'react-router-dom';
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { Grid, Typography, Box, Dialog, TextField, FormGroup, FormControl, Checkbox, DialogContent, Button, FormControlLabel, checkboxClasses, CircularProgress } from '@mui/material'
import LanguageSelect from "./forms/LanguageSelect";
import Footer from "./Footer";
import Loading from "./Loading";
import { getLanding } from "../actions/viewinstance"
import { fetchErrorMessages, selectErrorMessagesByNegativeCode } from "../reducers/reference_errormessages";
import { userLogin } from "../reducers/auth";
import { clientlogoClear } from "../reducers/reference_clientlogo";
import { navmenuClear } from "../reducers/reference_navmenu";

import { participantBiometricClear } from "../reducers/admincenter_biometrics";
import { datareportClear } from "../reducers/admincenter_datareport";
import { admingroupsClear } from "../reducers/admincenter_groups";
import { participantaddressClear } from "../reducers/admincenter_participantaddress";
import { participantdemographicClear } from "../reducers/admincenter_participantdemographics";
import { participantinviteClear } from "../reducers/admincenter_participantinvite";
import { participantmergeClear } from "../reducers/admincenter_participantmerge";
import { participantmiscClear } from "../reducers/admincenter_participantmisc";
import { participantmoveClear } from "../reducers/admincenter_participantmove";
import { participantpasswordClear } from "../reducers/admincenter_participantpassword";
import { participantphoneClear } from "../reducers/admincenter_participantphone";
import { participantresponseClear } from "../reducers/admincenter_responses";
import { reportcriteriaClear } from "../reducers/admincenter_reportcriteria";
import { adminparticipantClear } from "../reducers/admincenter_participants";
import { uireportClear } from "../reducers/admincenter_uireport";
import { profileClear } from "../reducers/profile";

import { useTheme } from "@mui/material/styles"
import { globalsettingSet, selectGlobalSettingEntities } from "../reducers/reference_settings";
import { viewinstanceClear } from "../reducers/reuseable_vi";
import { contextUpsert } from "../reducers/global_contexts";
import { userTimeoutSecondsRemaining } from "../reducers/auth_timeout";
import { fetchPWRequest, fetchSelfRegAndPWRequest, fetchSelfRegistration, pwrequestClearVI } from "../reducers/pwrequest";


const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};

const Login = (props) => {
  const navigate = useNavigate();
  const form = useRef();
  const checkBtn = useRef();
  const theme = useTheme();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [signupOpen, setSignUpOpen] = useState(false);
  const [signupComplete, setSignUpComplete] = useState(false);

  const [searchParams] = useSearchParams();
  const [timeoutChecked, setTimeoutChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [callVI, setCallVI] = useState(false)
  const [settingsLoaded, setSettingsLoaded] = useState(false)
  const { user: currentUser } = useSelector((state) => state.auth);
  // const { isLoggedIn } = useSelector(state => state.auth);
  const { message } = useSelector(state => state.message);
  const { viewInstance, settings } = useSelector(state => state.viewinstance)
  const globcon = useSelector((state) => state.contexts.entities)


  const errormessageStatus = useSelector(state => state.errormessages.status)

  const dispatch = useDispatch();


  const loginStatus = useSelector(state => state.auth.status)
  const timeoutsStatus = useSelector(state => state.timeouts.status)
  const isTimedOut = useSelector(state => state.timeouts.isTimedOut)
  const loginError = useSelector(state => state.auth.error)
  const ErrorMessage = useSelector(state => selectErrorMessagesByNegativeCode(state, loginError && loginError.ErrorID))
  const [isError, setIsError] = useState(false)
  const { SelfRegister } = viewInstance?.LoginPage ? viewInstance.LoginPage : { SelfRegister: { PopUpStart: {}, PopUpComplete: {} } }

  const pwStatus = useSelector(state => state.pwrequest.status)
  const pwError = useSelector(state => state.pwrequest.error)

  const [RequireFirstName, setRequireFirstName] = useState(true)
  const [RequireLastName, setRequireLastName] = useState(true)
  const [RequireEmail, setRequireEmail] = useState(true)

  const [ValidatedFirstName, setValidatedFirstName] = useState(null)
  const [ValidatedLastName, setValidatedLastName] = useState(null)
  const [ValidatedEmail, setValidatedEmail] = useState(null)
  const [ValidatedUsername, setValidatedUsername] = useState(null)

  const [TouchedFirstName, setTouchedFirstName] = useState(false)
  const [TouchedLastName, setTouchedLastName] = useState(false)
  const [TouchedEmail, setTouchedEmail] = useState(false)
  const [TouchedUsername, setTouchedUsername] = useState(false)

  const [fieldChecksPassed, setFieldChecksPassed] = useState(false)

  const [RegisterFirstName, setRegisterFirstName] = useState('')
  const [RegisterLastName, setRegisterLastName] = useState('')
  const [RegisterEmail, setRegisterEmail] = useState('')
  const [RegisterUsername, setRegisterUsername] = useState('')

  useEffect(() => {

    if (currentUser) {
      dispatch(userTimeoutSecondsRemaining())
    }
    if (!timeoutChecked) {
      setTimeoutChecked(true)
    }
  }, [currentUser])

  useEffect(() => {
    if (pwStatus === 'idle' && signupComplete) {
      setSignUpComplete(false)
    }
    else if (pwStatus === 'success' && !signupComplete) {
      setSignUpComplete(true)
    }
  }, [pwStatus])

  useEffect(() => {
    if (!signupOpen) {
      handleStateClear()
      setFieldChecksPassed(false)
    }
  }, [signupOpen])

  useEffect(() => {
    validateRegistration("FIRST")
    validateAllRegistration()
  }, [RegisterFirstName])
  useEffect(() => {
    validateRegistration("LAST")
    validateAllRegistration()
  }, [RegisterLastName])
  useEffect(() => {
    validateRegistration("EMAIL")
    validateAllRegistration()
  }, [RegisterEmail])
  useEffect(() => {
    validateRegistration("USER")
    validateAllRegistration()
  }, [RegisterUsername])


  useEffect(() => {

    if (timeoutChecked && currentUser && loginStatus === 'success' && timeoutsStatus !== 'loading' && isTimedOut === false) {

      dispatch(clientlogoClear())
      dispatch(navmenuClear())

      navigate("/home");
      //window.location.reload();
    }
    else if (timeoutChecked && currentUser && loginStatus === 'success' && isTimedOut === true) {
      localStorage.removeItem('persist:root')
      localStorage.removeItem('_persist')
    }
    else if (loginStatus === "failed") {
      setLoading(false)
      setIsError(true)
    }
  }, [loginStatus, timeoutChecked, currentUser, timeoutsStatus, isTimedOut])

  useEffect(() => {
    localStorage.removeItem('persist:root')
    localStorage.removeItem('_persist')


    // participant
    dispatch(participantBiometricClear())
    dispatch(participantaddressClear())
    dispatch(participantdemographicClear())
    dispatch(participantinviteClear())
    dispatch(participantmergeClear())
    dispatch(participantmiscClear())
    dispatch(participantmoveClear())
    dispatch(participantpasswordClear())
    dispatch(participantphoneClear())
    dispatch(adminparticipantClear())
    dispatch(profileClear())
    // admin center
    dispatch(admingroupsClear())


    // reports
    dispatch(datareportClear())
    dispatch(reportcriteriaClear())
    dispatch(uireportClear())


    // survey data
    dispatch(participantresponseClear())

    // other data
    dispatch(viewinstanceClear({ ViewInstanceId: "HomePage" }))
    if (!searchParams.get("g")) {
      return <Navigate to="/NotFound" />
    }

    localStorage.setItem("group", searchParams.get("g"))


    if (!callVI && (!viewInstance || !viewInstance.LoginPage)) {
      setCallVI(true)
      dispatch(getLanding(searchParams.get("g"), -1))
    }


  }, [window.location.pathname])

  useEffect(() => {
    if (errormessageStatus === 'idle' && searchParams.get("g").length > 0) {
      dispatch(fetchErrorMessages({ groupGuid: searchParams.get("g"), languageID: -1 }))
    }
  }, [errormessageStatus, dispatch])

  useEffect(() => {
    if (!settingsLoaded && settings) {
      dispatch(globalsettingSet({ SettingFamilyKeyName: 'organization', Settings: settings.OrganizationSettingValues }))
      dispatch(contextUpsert({ Key: "UnitOfMeasure", Value: settings.OrganizationSettingValues[0].List['QUESTION UOM TEMPLATE'] }))
      dispatch(contextUpsert({ Key: "LanguageName", Value: settings.OrganizationSettingValues[0].List['LANGUAGE'] }))
      setRequireFirstName(settings.OrganizationSettingValues[0].List['REQUIRE NAME FIRST'] === '0' ? false : true)
      setRequireLastName(settings.OrganizationSettingValues[0].List['REQUIRE NAME LAST'] === '0' ? false : true)
      setRequireEmail(settings.OrganizationSettingValues[0].List['REQUIRE EMAIL'] === '0' ? false : true)
      setSettingsLoaded(true)
    }
  }, [settings,settingsLoaded, dispatch])

  const onChangeUsername = (e) => {
    const username = e.target.value;
    setUsername(username);
  };

  const onChangePassword = (e) => {
    const password = e.target.value;
    setPassword(password);
  };

  const handleLogin = (e) => {
    e.preventDefault();

    setLoading(true);
    setIsError(false)

    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      dispatch(userLogin({ "GroupGuid": searchParams.get("g"), "Username": username, "Password": password, language: globcon['LanguageName'] || -1, unitofmeasure: globcon['UnitOfMeasure'] }))

    } else {
      setLoading(false);
    }
  };
  const handleSignUpOpen = (e) => {
    if (!signupOpen) {
      setSignUpOpen(true)
    }
  }
  const handleSignUpClose = (e) => {
    if (signupOpen) {

      setSignUpOpen(false)
      dispatch(pwrequestClearVI())
    }


  }

  const handleStateClear = () => {

    setRegisterFirstName('')
    setRegisterLastName('')
    setRegisterEmail('')
    setRegisterUsername('')
    
    setValidatedFirstName(null)
    setValidatedLastName(null)
    setValidatedEmail(null)
    setValidatedUsername(null)

    setTouchedFirstName(false)
    setTouchedLastName(false)
    setTouchedEmail(false)
    setTouchedUsername(false)

    setSignUpComplete(false)
    setFieldChecksPassed(false)
  }


  const handleSubmit = (e) => {

    dispatch(fetchSelfRegAndPWRequest(
      {
        GroupGuid: searchParams.get("g")
        , Username: RegisterUsername
        , Email: RegisterEmail
        , FirstName: RegisterFirstName
        , LastName: RegisterLastName
        , LanguageID: globcon.LanguageId
        , SystemComponentKeyName: "SELF_REGISTRATION_EMAIL"
      }
    ))

  }

  const handleValueChange = (what, value) => {
    if (what === 'FirstName') {
      setRegisterFirstName(value)
      if(!TouchedFirstName){
        setTouchedFirstName(true)
      }
    }
    if (what === 'LastName') {
      setRegisterLastName(value)
      if(!TouchedLastName){
        setTouchedLastName(true)
      }
    }
    if (what === 'Email') {
      setRegisterEmail(value)
      if(!TouchedEmail){
        setTouchedEmail(true)
      }
    }
    if (what === 'Username') {
      setRegisterUsername(value)
      if(!TouchedUsername){
        setTouchedUsername(true)
      }
    }

  }

  const validateRegistration = (specific) => {
    let failures = 0;
    if (specific === 'FIRST') {
      if ((RequireFirstName && !RegisterFirstName)) {
        failures += 1
        setValidatedFirstName(false)
      } else {
        setValidatedFirstName(true)
      }
      console.log(RegisterFirstName)
    }
    
    if (specific === 'LAST') {
      if ((RequireLastName && !RegisterLastName)) {
        failures += 1
        setValidatedLastName(false)
      } else {
        setValidatedLastName(true)
      }
    }

    if (specific === 'EMAIL') {
      if (!RegisterEmail
        || 
          !(/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/u).test(RegisterEmail)
      ) {
        failures += 1
        setValidatedEmail(false)
      } else {
        setValidatedEmail(true)
      }
    }

    if (specific === 'USER') {
      if ((!RegisterUsername)) {
        failures += 1
        setValidatedUsername(false)
      } else {
        setValidatedUsername(true)
      }
    }
  }

  const validateAllRegistration = () => {
    let failures = 0;
    if ((RequireFirstName && !RegisterFirstName)) {
      failures += 1
    }

    if ((RequireLastName && !RegisterLastName)) {
      failures += 1
    }

    if ((!RegisterEmail)

      || (
        !(/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/u).test(RegisterEmail)

      )
    ) {
      failures += 1
    }
    if ((!RegisterUsername)) {
      failures += 1
    }

    if (failures > 0) {
      setFieldChecksPassed(false)
    } else {
      setFieldChecksPassed(true)
    }
  }


  // if (timeoutChecked && currentUser && loginStatus ==='success' && timeoutsStatus !=='loading' && isTimedOut===false) {
  //   return <Navigate to="/home" />;
  // }else if(timeoutChecked && currentUser && loginStatus ==='success' && isTimedOut===true) {
  //   return <Navigate to="/logout"/>
  // }

  if (viewInstance && viewInstance.LoginPage && theme.palette.primary.main === settings.OrganizationSettingValues[0].List['THEME COLOR'] && settingsLoaded) {
    return (
      <div class="container">
        <div className="row" style={{ backgroundImage: "url('heroimage.PNG')", backgroundRepeat: "no-repeat", backgroundSize: "cover", marginTop: "10vh", float: 'right', width: '100%', borderRadius: '20px' }}>
          <div class="col-md-7"></div>
          {viewInstance && settings && (<div className="col-md-5" style={{ background: "white", borderRadius: '0 20px 20px 0', height: '585px' }}>
            {viewInstance.LoginPage.LanguageDropdownList
              &&
              <LanguageSelect
                MeasurementOptions={viewInstance.LoginPage.MeasurementOptions}
                LanguageOptions={viewInstance.LoginPage.LanguageDropdownList}
                languageName={settings.OrganizationSettingValues[0].List['LANGUAGE']}
                uomName={settings.OrganizationSettingValues[0].List['QUESTION UOM TEMPLATE']}
                groupGuid={searchParams.get("g")}
                settings={settings.OrganizationSettingValues[0].List}
              />
            }<a href={viewInstance.LoginPage.ClientLogo.ClientLogoExternalLink} target="_blank">
              <img src={"../" + viewInstance.LoginPage.ClientLogo.ClientLogoSource} alt={viewInstance.LoginPage.ClientLogo.ClientLogoAltText} style={{ width: '100%' }} />
            </a>

            <Form onSubmit={handleLogin} ref={form}>
              <div className="form-group">
                <label htmlFor="username">{viewInstance.LoginPage.UsernameInputBox.UsernameTextValue}</label>
                <Input
                  type="text"
                  className="form-control"
                  name="username"
                  value={username}
                  onChange={onChangeUsername}
                  validations={[required]}
                  aria-invalid={isError ? 'true' : 'false'}
                  aria-describedby={isError ? 'login-error' : ''}
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">{viewInstance.LoginPage.PasswordInputBox.PasswordTextValue}</label>
                <Input
                  type="password"
                  className="form-control"
                  name="password"
                  value={password}
                  onChange={onChangePassword}
                  validations={[required]}
                  aria-invalid={isError ? 'true' : 'false'}
                  aria-describedby={isError ? 'login-error' : ''}
                />
              </div>
              <Link to={"/request?g=" + searchParams.get("g")} style={{ fontSize: "smaller", float: "right", marginBottom: "10px" }}>{viewInstance.LoginPage.ForgotPasswordLink}</Link>
              <div className="form-group">
                <button className="btn btn-primary btn-block" style={{ backgroundColor: settings.OrganizationSettingValues[0].List['THEME COLOR'], borderColor: settings.OrganizationSettingValues[0].List['THEME COLOR'] }} disabled={loading}>
                  {(loading) && (
                    <span className="spinner-border spinner-border-sm"></span>
                  )}
                  <span>{viewInstance.LoginPage.LoginButton}</span>
                </button>
              </div>
              {settings.OrganizationSettingValues[0].List['SELF SIGNUP ALLOWED'] == "1" && (

                <Typography variant="body2" sx={{ "&:hover": { textDecoration: "underline", cursor: "pointer" } }} onClick={handleSignUpOpen}>{viewInstance.LoginPage.SelfRegister.LoginText}</Typography>
              )}

              {message && (
                <div className="form-group">
                  <div className="alert alert-danger" role="alert">
                    {message}
                  </div>
                </div>
              )}
              <CheckButton style={{ display: "none" }} ref={checkBtn} />
            </Form>

            {isError === true && (

              <Grid item xs={10} md={8}>
                <Box>
                  <Typography variant="h6" color="error" align="center" role="alert">
                    {
                      (ErrorMessage && ErrorMessage.length > 0 && ErrorMessage[0].MessageTypeContent)
                      ||
                      (loginError && loginError.ErrorMessage)
                    }
                  </Typography>
                </Box>
              </Grid>
            )}
            <Dialog open={signupOpen} onClose={handleSignUpClose} >
              <DialogContent>
                <Box p={2}>

                  { // code here will avoid react component refreshing (vs in its own const=>() component)
                    !signupComplete && (
                      <Grid container direction="row" spacing={2} justifyContent="center" alignItems="center">
                        <Grid item xs={12}>
                          <Typography variant="h5" align="center">{SelfRegister.PopUpStart.Title}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography variant="body1" align={"center"}>{SelfRegister.PopUpStart.Description}</Typography>
                        </Grid>
                        {RequireFirstName  && (

                          <Grid item xs={6}>
                            <TextField
                              variant="standard"
                              label={SelfRegister.PopUpStart.FirstNameLabel}
                              value={RegisterFirstName}
                              error={!ValidatedFirstName && ValidatedFirstName != null && TouchedFirstName}
                              fullWidth
                              onChange={(e) => handleValueChange("FirstName", e.target.value)}
                            />
                          </Grid>
                        )}
                        {RequireLastName && (

                          <Grid item xs={6}>
                            <TextField
                              variant="standard"
                              label={SelfRegister.PopUpStart.LastNameLabel}
                              value={RegisterLastName}
                              error={!ValidatedLastName && ValidatedLastName != null && TouchedLastName}
                              fullWidth
                              onChange={(e) => handleValueChange("LastName", e.target.value)} />
                          </Grid>
                        )}
                        <Grid item xs={12}>
                          <TextField
                            variant="standard"
                            label={SelfRegister.PopUpStart.UsernameLabel}
                            value={RegisterUsername}
                            fullWidth
                            error={(pwStatus == 'failed' && pwError.ErrorId === '-190') || (!ValidatedUsername && ValidatedUsername!=null && TouchedUsername)}
                            onChange={(e) => handleValueChange("Username", e.target.value)}

                            helperText={
                              pwStatus == 'failed' && pwError.ErrorID === '-190' ?
                                <Typography variant="caption" color={"error"}>{SelfRegister.PopUpStart.UsernameErrorMessage} {" "}
                                  <Link to={"/request?g=" + searchParams.get("g")} style={{ color: "blue" }}>{SelfRegister.PopUpStart.UsernameErrorMessage2}.</Link>
                                </Typography>
                                : <Typography></Typography>
                            }
                          />

                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            variant="standard"
                            label={SelfRegister.PopUpStart.EmailLabel}
                            value={RegisterEmail}
                            fullWidth
                            error={!ValidatedEmail && ValidatedEmail != null && TouchedEmail}

                            onChange={(e) => handleValueChange("Email", e.target.value)}
                          />
                        </Grid>
                        <Grid item xs={5}>
                          <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            onClick={handleSubmit}
                            disabled={!fieldChecksPassed}

                          >
                            <Box flex flexDirection={"row"}>

                              {pwStatus === 'loading' && <CircularProgress size={"5"} sx={{ color: "white", mr: 2 }} />}
                              {SelfRegister.PopUpStart.ButtonText}
                            </Box>
                          </Button>
                        </Grid>
                        {pwStatus === "failed" &&
                          pwError.ErrorID !== '-190' &&
                          (

                            <Grid item xs={12}>
                              <Typography variant="body2" color={"error"}>{pwError.ErrorMessage}</Typography>
                            </Grid>
                          )
                        }
                      </Grid>
                    )
                  }
                  { // code here will avoid react component refreshing (vs in its own const=>() component)


                    signupComplete && (
                      <Grid container direction="row" spacing={2} justifyContent="center" alignItems="center">
                        <Grid item xs={12}>
                          <Typography variant="h5" align="center">{SelfRegister.PopUpComplete.Title}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography variant="body1" align="center">{SelfRegister.PopUpComplete.Description}</Typography>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <Button variant="contained" onClick={handleSignUpClose} fullWidth color="primary">{SelfRegister.PopUpComplete.ButtonText}</Button>
                        </Grid>
                      </Grid>
                    )
                  }
                </Box>

              </DialogContent>

            </Dialog>
            <div style={{ position: "absolute", bottom: "0", textAlign: "center", width: "90%", fontSize: "smaller" }}>
              <Footer footer={viewInstance.LoginPage.FooterFrame} />
            </div>
          </div>
          )

          }

        </div></div>
    );
  } else {
    return (
      <Loading />
    )
  }

};

export default Login;